var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseInputText,{attrs:{"name":"search","data-cy":_vm.dataCy,"label":_vm.hideLabel ? '' : 'Buscar',"icon":"fas fa-search","placeholder":_vm.placeholder,"value":_setup.searchValue,"disabled":_vm.disabled},on:{"input":_setup.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }